
    import "src/shared/components/SideDrawer/index.module.scss?farm_css_modules";
    
    export default {"drawer": `drawer-1c1ef36d`,"hamburgForNavbar": `hamburgForNavbar-1c1ef36d`,"hamburgForNavbarRight": `hamburgForNavbarRight-1c1ef36d`,"navbarDrawer": `navbarDrawer-1c1ef36d`,"navbarForLargeScreen": `navbarForLargeScreen-1c1ef36d`,"sideDrawer": `sideDrawer-1c1ef36d`}
    